// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: 48,
		/* Optional */
		loadProductFirst: true,
		filterTreeMobileStyle: 'style4',
    }
};

// Declare Templates
var boostPFSTemplate = {
  // Grid Template
  productGridItemHtml: [
    '<div class="grid-item one-two large--one-three padding-bottom--up-1">',
    '<article class="position-relative">',
    '<div class="position-relative">',
      "{{ itemImage }}",
      "{{ itemBadges }}",
    '</div>',
    '<div class="swatch-wrapper"></div>',
    "{{ itemPlugOptionsMaterials }}",
    "{{ itemPlugOptionsInlays }}",
    "{{ itemTitle }}",
    "{{ itemPrice }}",
    "{{ itemReviews }}",
    "</article>",
    "</div>",
  ].join(""),

  // Pagination Template
  previousActiveHtml: "",
  previousDisabledHtml: "",
  nextActiveHtml: "",
  nextDisabledHtml: "",

  pageItemHtml: [
    '<li class="grid-item padding-bottom--down-2">',
    '<a href="{{itemUrl}}">',
    '<div class="border-radius-full flex-bar flex-center border-grey-1" style="width: 30px; height: 30px;">',
    '<div class="font-size--down-2 line-height--down-4 text-grey-3">',
    "{{itemTitle}}",
    "</div>",
    "</div>",
    "</a>",
    "</li>",
  ].join(""),

  pageItemSelectedHtml: [
    '<li class="grid-item padding-bottom--down-2">',
    '<div class="border-radius-full flex-bar flex-center border-default" style="width: 30px; height: 30px;">',
    '<div class="font-size--down-2 line-height--down-4 text-default">',
    "{{itemTitle}}",
    "</div>",
    "</div>",
    "</li>",
  ].join(""),

  pageItemRemainHtml: [
    '<li class="grid-item padding-bottom--down-2">',
    "<span>{{itemTitle}}</span>",
    "</li>",
  ].join(""),

  paginateHtml: [
    '<div class="text-center">',
    '<div class="overflow-hidden">',
    '<ul class="grid-bar--down-2 margin-bottom-negative--down-2 font-size--none margin-bottom--none">',
    "{{pageItems}}",
    "</ul>",
    "</div>",
    "</div>",
  ].join(""),

  // Sorting Template
  sortingHtml:
    '<button type="button" aria-label="Sort">' +
    boostPFSThemeConfig.label.sorting +
    '</button><ul class="boost-pfs-filter-sort-dropdown ">{{sortingItems}}</ul>',
};

(function() {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
    has_swatch = false;
		images = [],
		firstVariant = {},
		boostPFSImgDefaultSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
		boostPFSRangeWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];


	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
    has_swatch = false;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		itemHtml = itemHtml
      .replace('{{ itemImage }}', buildItemImage(data))
      .replace('{{ itemTitle }}', buildItemTitle(data))
      .replace('{{ itemPlugOptionsMaterials }}', buildItemPlugOptionsMaterials(data))
      .replace('{{ itemPlugOptionsInlays }}', buildItemPlugOptionsInlays(data))
      .replace('{{ itemPrice }}', buildItemPrice(data))
      .replace('{{ itemBadges }}', buildItemBadges(data))
      .replace('{{ itemReviews }}', buildItemReviews(data));

      return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  	
    function buildItemImage(data) {
      var html = '';
      data.images = data.images_info;

      if (!data.images.length) {
        return html;
      }

      var alt_image_src = '';
      var alt_image_alt = data.title;
      var title = data.title
      if(data.metafields.length) {
        data.metafields.forEach(function(meta) {
          if(meta.namespace === "featured_image") {
            alt_image_src = JSON.parse(meta.value)[0]['src'] + '&transform=resize=350'
          } else if(meta.namespace === "lifestyle_gallery_im") {
            if (meta.key == "image" && alt_image_src === "") {
              alt_image_src =
                JSON.parse(meta.value)[0] + "&transform=resize=350";
            }
            if(meta.key == 'alt') {
              alt_image_alt = JSON.parse(meta.value)[0].replace('{{ product title }}', '') + ' ' + title;
            }
          }
        })
      }
      if(images.length > 1 && alt_image_src == '') {
        alt_image_src = images[1]['src'];
      }
  

      if(alt_image_src !== '') {
        alt_class = 'has-alt-image background-full position-relative'
      } else {
        var alt_class = ''
        }
      var image_alt = data.title; 
      if(images[0]['alt'] !== null) {
        image_alt = images[0]["alt"].replace("{{ product title }}", data.title);
      }
      html = [
        '<a href="' + Utils.buildProductItemUrl(data) + '">',
        '<div class="overflow-hidden border-grey-1 border-radius-default">',
        '<div class="image-container box-ratio--1-1 box-placeholder ' + alt_class + '">',
        '<img class="alt-image" loading="lazy" src="' + alt_image_src + '" alt="' + alt_image_alt + '"/>',
        '<img class="main-image" loading="eager" src="' + Utils.optimizeImage(images[0]['src']) + '" alt="' + image_alt + '" />',
        '</div>',
        '</div>',
        '</a>',
      ].join('');

      return html;
    };

    function buildItemTitle(data) {
      var html = [
        '<h2 class="margin-top--0 font-size--down-2 line-height--up-4 large--font-size--0 large--line-height--up-6 font-weight-700 text-center margin-bottom--down-4">',
        '<a href="' + Utils.buildProductItemUrl(data) + '">',
        data.title,
        '</a>',
        '</h2>'
      ].join('');

      return html;
    };

    function buildItemPlugOptionsMaterials(data) {

      var product_plug = data.tags.includes(boostPFSThemeConfig.custom.product_plug_tag);
      // has_swatch = false;
      var product_plug_materials = false;
      var linked_products;
      data.metafields.forEach((field) => {
        if(field.namespace === 'product_swatches') {
          linked_products = field.value.split('|').join(',');
        }
      });

      var product_plug_materials_names = boostPFSThemeConfig.custom.product_plug_materials_names;

      var html = '';

      if (product_plug_materials_names && product_plug_materials_names.length) {
        product_plug_materials_names.forEach((product_plug_materials_name) => {
          var product_plug_materials_name_handle = toHandle(product_plug_materials_name);

          if (data.handle.includes(product_plug_materials_name_handle)) {
            product_plug_materials = true;
          }
        });
      }

      if (!product_plug || !product_plug_materials || has_swatch) {
        return html;
      }

      has_swatch = true;

      var materials = product_plug_materials_names
      .map(function(material_name, index) {
        var material_image_url = boostPFSThemeConfig.custom.product_plug_materials_images_urls[index];
        var material_name_handle = boostPFSThemeConfig.custom.product_plug_materials_handles[index];

        var material_handle = toHandle(material_name_handle);

        var material_url = product_plug_materials_names.reduce(function(acc, _material_name) {
          var _material_handle = toHandle(_material_name);
          var acc = acc || '';
          acc = acc.replace(_material_handle, material_handle);

          return acc;
        }, Utils.buildProductItemUrl(data));

        var material_product_handle = material_url.split('/').pop().split('?')[0];

        var image = '';

        if (material_image_url) {
          image = [
            '<div class="overflow-hidden border-radius-full box-grey-1 position-relative border-grey-4" style="width: 40px; height: 40px;">',
            '<img class="object-full position-absolute position-full one height-full" src="' + material_image_url + '" alt="' + material_name + '" />',
            '</div>'
          ].join('');
        }

        return [
          '<li class="product-link grid-item padding-bottom--down-3" data-module-linked-products=\'{',
          '"handles": "' + linked_products + '"',
          '}\'',
          'data-module-product-link=\'{',
          '"handle": "' + material_product_handle + '",',
          '"url": "' + material_url + '"',
          '}\'>',
          '<a href="' + material_url + '">',
          '<div class="tooltip">',
          '<div class="tooltip-text">',
          material_name,
          '</div>',

          image,
          '</div>',
          '</a>',
          '</li>'
        ].join('');
      })
      .join('');

      html = [
        '<div class="margin-bottom--down-3">',
        '<div class="nowrap scroll-horizontal hide-scrollbar">',
        '<ul class="grid--down-3 margin-bottom-negative--down-3 text-center">',
        materials,
        '</ul>',
        '</div>',
        '</div>'
      ].join('');

      return html;
  };

  async function buildItemPlugSwatches(data, element) {
    fetch(`/search/suggest?q=id:${data.id}&resources[type]=product&section_id=product-swatches`)
      .then(res => res.text())
      .then(res => {
        console.log(res);
        const parse = new DOMParser();
        const html = parse.parseFromString(res, 'text/html').querySelector('#shopify-section-product-swatches');
        // if (element.$element[0].querySelectorAll('[data-module-product-link]').length) return;
        if (html.querySelectorAll("ul li").length) {
          element.$element[0].querySelector(".swatch-wrapper").innerHTML = res;
          element.$element[0].querySelectorAll("[data-module-product-link]").forEach(function (elem) {
            elem.remove();
          })
        }
      });
  };

  function buildItemPlugOptionsInlays(data) {
      var product_plug = data.tags.includes(boostPFSThemeConfig.custom.product_plug_tag);
      // has_swatch = false;
      var product_plug_inlays = false;

      var product_plug_inlays_names = boostPFSThemeConfig.custom.product_plug_inlays_names;

      var html = '';

      if (product_plug_inlays_names && product_plug_inlays_names.length) {
        product_plug_inlays_names.forEach((product_plug_inlays_name) => {
          var product_plug_inlays_name_handle = toHandle(product_plug_inlays_name);

          if (data.handle.includes(product_plug_inlays_name_handle)) {
            product_plug_inlays = true;
          }
        });
      }

      if (!product_plug || !product_plug_inlays || has_swatch) {
        return html;
      }

      has_swatch = true;

      var inlays = product_plug_inlays_names
      .map(function(inlay_name, index) {
        var inlay_image_url = boostPFSThemeConfig.custom.product_plug_inlays_images_urls[index];

        var inlay_handle = toHandle(inlay_name);

        var inlay_url = product_plug_inlays_names.reduce(function(acc, _inlay_name) {
          var _inlay_handle = toHandle(_inlay_name);
          var acc = acc || '';
          acc = acc.replace(_inlay_handle, inlay_handle);

          return acc;
        }, Utils.buildProductItemUrl(data));

        var inlay_product_handle = inlay_url.split('/').pop().split('?')[0];

        var image = '';

        if (inlay_image_url) {
          image = [
            '<div class="overflow-hidden border-radius-full box-grey-1 position-relative border-grey-4" style="width: 40px; height: 40px;">',
            '<img class="object-full position-absolute position-full one height-full" src="' + inlay_image_url + '" alt="' + inlay_name + '" />',
            '</div>'
          ].join('');
        }

        return [
          '<li class="product-link grid-item padding-bottom--down-3" data-module-product-link=\'{',
          '"handle": "' + inlay_product_handle + '",',
          '"url": "' + inlay_url + '"',
          '}\'>',
          '<a href="' + inlay_url + '">',
          '<div class="tooltip">',
          '<div class="tooltip-text">',
          inlay_name,
          '</div>',

          image,
          '</div>',
          '</a>',
          '</li>'
        ].join('');
      })
      .join('');

      html = [
        '<div class="margin-bottom--down-3">',
        '<div class="nowrap scroll-horizontal hide-scrollbar">',
        '<ul class="grid--down-3 margin-bottom-negative--down-3 text-center">',
        inlays,
        '</ul>',
        '</div>',
        '</div>'
      ].join('');

      return html;
    };

    function buildItemPrice(data) {
      var prefix = '';

      var compare = '';
      debugger;
      if (data.price_varies) {
        prefix = boostPFSThemeConfig.label.from;
      }

      if (data.compare_at_price_min > data.price_min) {
        compare = [
          '<s>',
          Utils.formatMoney(data.compare_at_price_min),
          '</s>'
        ].join('');
      }

      var html = [
        '<div class="font-size--down-2 line-height--up-4 large--font-size--0 large--line-height--up-6 font-weight-700 text-center">',
        prefix + ' ',

        '<span class="' + (data.compare_at_price_min > data.price_min ? 'text-pink' : '') + '">',
        Utils.formatMoney(data.price_min),
        '</span>',

        ' ',

        compare,
        '</div>'
      ].join('');

      return html;
    };

    function buildItemBadges(data) {
      var html = '';

      var html_sale = '';

      var html_new = '';
      if (data.compare_at_price_min > data.price_min && !data.tags.includes('no_sale_label')) {
        html_sale = [
          '<div class="margin-bottom--down-3">',
          '<div class="box-pink small--padding-left-right--down-3 small--padding-top-bottom--down-3 padding-top-bottom--down-3 padding-left-right--up-2 border-radius-default">',
          '<div class="font-size--down-2 line-height--up-4 font-weight-700 text-light">',
          boostPFSThemeConfig.label.sale,
          '</div>',
          '</div>',
          '</div>'
        ].join('');
      }

      if (data.tags.includes('new category') && !data.tags.includes('no_new_label')) {
        html_new = [
          '<div class="margin-bottom--down-3">',
          '<div class="box-purple small--padding-left-right--down-3 small--padding-top-bottom--down-3 padding-top-bottom--down-3 padding-left-right--up-2 border-radius-default">',
          '<div class="font-size--down-2 line-height--up-4 font-weight-700 text-light">',
          boostPFSThemeConfig.label.new,
          "</div>",
          "</div>",
          "</div>",
        ].join("");
      }

      if (data.compare_at_price_min > data.price_min || data.tags.includes('new category') && (!data.tags.includes('no_new_label') || !data.tags.includes('no_sale_label'))) {
        html = [
          '<div class="no-pointer">',
          '<div class="position-absolute small--position-top--down-5 small--position-right--down-5 position-top--up-1 position-right--up-1">',
          '<div class="last-child-margin--none">',
          html_sale,
          html_new,
          '</div>',
          '</div>',
          '</div>'
        ].join('');
      }
      if (data.tags.includes("spookytag")) {
        html += [
          '<div class="no-pointer">',
          '<div class="position-absolute small--position-top--down-5 small--position-right--down-5 position-top--up-1 position-right--up-1">',
          '<div class="last-child-margin--none">',
          '<div class="margin-bottom--down-3">',
          '<div class="box-spooky padding-top-bottom--down-3 padding-left-right--up-2 border-radius-default">',
          '<div class="font-size--down-2 line-height--up-4 font-weight-700 text-light">',
          boostPFSThemeConfig.label.spooky,
          "</div>",
          "</div>",
          "</div>",
          "</div>",
          "</div>",
          "</div>",
        ].join("");
      }
      if (data.tags.includes("sterilisation")) {
        html += [
          '<div class="no-pointer sterilisation-badge">',
          '<div class="last-child-margin--none">',
          '<div class="box-sterilisation padding--down-4">',
          '<div class="font-size--down-3 small--font-size--down-8 small--line-height--down-5 line-height--0 font-weight-700 text-caps text-center text-light">',
          boostPFSThemeConfig.label.sterilisation,
          "</div>",
          "</div>",
          "</div>",
          "</div>",
        ].join("");
      }
      return html;
    };

  function buildItemReviews(data) {
      var html = [
        '<div class="margin-top--down-3">',
        '<div class="text-center">',
        '<div class="wc_product_review_badge" data-handle="' + data.handle + '" data-product_id="' + data.id + '"></div>',
        '</div>',
        '</div>'
      ].join('');

      return html;
    };

    function toHandle(string) {
      return string.toLowerCase().replace(/[^\w ]+/g,'').replace(/ +/g,'-');
    };

// 	function buildReview(data) {
// 		var html = '';
// 		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
// 			boostPFSThemeConfig.custom.show_product_review == true) {
// 			html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
// 		}
// 		return html;
// 	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    console.log('total products ', totalProduct)
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_toolbar_sort_by && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					activeClass = '';
					if (paramSort == k) {
						activeClass = 'boost-pfs-filter-sort-item-active';
					}
					sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass + '">' + sortingArr[k] + '</a></li>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function() {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		var _this = this;
		jQ('.boost-pfs-filter-sort-dropdown a').click(function(e) {
			e.preventDefault();
      e.stopImmediatePropagation();
			FilterApi.setParam('sort', jQ(this).data('sort'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
      jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-sort-dropdown').hide();
		});

		jQ(".boost-pfs-filter-custom-sorting > button").click(function() {
			// if (!jQ('.boost-pfs-filter-filter-dropdown').is(':animated')) {
				jQ('.boost-pfs-filter-sort-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
			// }
		});

		// jQ('.boost-pfs-filter-top-sorting-mobile > button').click(function(e) {
    //   e.preventDefault()
		// 	jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-sort-dropdown').toggle();
		// });

		// jQ(document).on('click', function (e) {
    //   if (jQ(e.target).parents('.boost-pfs-filter-top-sorting').find(".boost-pfs-filter-filter-dropdown").length === 0) {
    //   	jQ('.boost-pfs-filter-filter-dropdown').hide().parent().removeClass('boost-pfs-filter-sort-active');
    //   }
    // });
	};
	// For Toolbar - Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>' + boostPFSThemeConfig.label.toolbar_viewas + '</span>';
		if (boostPFSThemeConfig.custom.product_item_type == 'grid') {
            if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>';
            } else {
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
            }
		} else {
            if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>';
            } else {
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
			    itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
            }
		}

		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

    var originalRenderProductDisplayType = ProductDisplayType.prototype.render;
    ProductDisplayType.prototype.render = function() {
        // Call the original function in our app lib.
        // We don't have to copy a very big function out here to modify.
        // function.call(this, param1, param2) binds the "this" pointer and params to the original function.
        originalRenderProductDisplayType.call(this);

        // Do your custom code after the original function has run
        // Active current display type
        if (this.$element.length) {
            this.$element.find(this.selector.productDisplayTypeList).removeClass('active');
            this.$element.find(this.selector.productDisplayTypeGrid).removeClass('active');
            if (Globals.queryParams.display == 'list') {
                this.$element.find(this.selector.productDisplayTypeList).addClass('active');
            } else if (Globals.queryParams.display == 'grid') {
        if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
            var curentGridColumn = boostPFSThemeConfig.custom.products_per_row;
            this.$element.find(this.selector.productDisplayTypeGrid).each(function(){
            var $parent = jQ(this).parent();
            var $cssNames = jQ('.boost-pfs-filter-top-display-type').attr('class').split(' ');
            var $activeClass = $cssNames[$cssNames.length - 1];
            var indexCurrentColumn = $activeClass.split('-')[$activeClass.split('-').length - 1];
            
            if($parent.hasClass('boost-pfs-filter-view-as-click') && jQ(this).data('view') == $activeClass){
                jQ(this).addClass('active');
                jQ('.boost-pfs-filter-product-item').removeClass(function(index, css) {
                return (css.match (/(^|\s)boost-pfs-filter-grid-width-\S+/g) || []).join(' ');
                }).addClass('boost-pfs-filter-grid-width-' + indexCurrentColumn);
            } else if(!$parent.hasClass('boost-pfs-filter-view-as-click') && jQ(this).data('view').split('-')[1] == curentGridColumn) {    
                jQ(this).addClass('active');
            }
            });

        } else {
            this.$element.find(this.selector.productDisplayTypeGrid).addClass('active');
        }
            }
        }
    }

	// Build Show Limit
	ProductLimit.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {

			var numberList = Settings.getSettingValue('general.showLimitList');
			if (numberList != '') {
				// Build content
				var showLimitItemsHtml = '';
				var arr = numberList.split(',');
				for (var k in sortingArr) {
					showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
				}
				html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			}
		}
		return html;
	};
	// Build Breadcrumb
	Breadcrumb.prototype.compileTemplate = function(colData) {
    if (!colData) colData = this.collectionData;
		var breadcrumbItemsHtml = '';
		if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
			if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
				var colInfo = colData.collection;
				if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
					breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
				} else {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
				}
			} else {
				breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'));
			}
		}
		return breadcrumbItemsHtml
	};

	/************************** END BUILD TOOLBAR **************************/

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;
    const element = this.$element;
    this.children.forEach(function (elem, index) {
      const thisData = data[index];
      buildItemPlugSwatches(thisData, elem);
    });
    
		// Intergrate Review Shopify
		if (window.SPR &&
			typeof window.SPR.initDomEls == 'function' &&
			typeof window.SPR.loadBadges == 'function' &&
			boostPFSThemeConfig.custom.show_product_review) {
			window.SPR.initDomEls();
			window.SPR.loadBadges();
    }
    
    if (window.wc_get_review_badge) {
      window.wc_get_review_badge(true);
    }
      
        setTimeout(function() {
          window.GlobalEvents.trigger('bcsffilter:buildextrasproductlist');
        });

        if (typeof window.BOLD !== 'undefined') {
          if (BOLD && BOLD.common && BOLD.common.eventEmitter) {
            BOLD.common.eventEmitter.emit("BOLD_CURRENCY_double_check");
          }
        }
	};

	// Build additional elements
	Filter.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		var totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>';
		if (data.total_product == 1) {
			totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_one + '</span>';
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
	};


    FilterApi.beforeCall = function(eventType, eventInfo) { 
          Globals.queryParams.currency = window.Shopify?.currency?.active;
          Globals.queryParams.currency_rate = Shopify.currency.rate;
          Globals.queryParams.return_all_currency_fields = false;
          Globals.queryParams.country = window.Shopify?.country
        }
})();